import React from "react";

/**
 * WhatsApp-Inspired Ambient Doodle & Mesh Background
 * Ultra-crisp, zero-bandwidth overhead, adaptive for both Light & Dark modes.
 */
export const AppBackground = () => {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden select-none"
    >
      {/* 1. Ambient Radial Lighting Glows (Soft Aura) */}
      <div className="absolute -top-[20%] -left-[10%] h-[500px] w-[500px] rounded-full bg-brand-500/5 dark:bg-emerald-500/5 blur-[120px]" />
      <div className="absolute top-[30%] -right-[15%] h-[600px] w-[600px] rounded-full bg-teal-500/5 dark:bg-teal-500/5 blur-[140px]" />
      <div className="absolute -bottom-[20%] left-[20%] h-[500px] w-[500px] rounded-full bg-emerald-500/5 dark:bg-brand-500/5 blur-[130px]" />

      {/* 2. WhatsApp Iconic Doodle Pattern Wallpaper */}
      <div
        className="absolute inset-0 opacity-[0.035] dark:opacity-[0.025] transition-opacity duration-500"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' stroke='%23059669' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'%3E%3C!-- Chat Bubble 1 --%3E%3Cpath d='M15 15h20a5 5 0 0 1 5 5v12a5 5 0 0 1-5 5h-10l-6 4v-4h-4a5 5 0 0 1-5-5V20a5 5 0 0 1 5-5z'/%3E%3C!-- Paper Plane --%3E%3Cpath d='M85 18l22 8-8 22-5-9-9-5 22-8z'/%3E%3Cpath d='M85 18l8 13'/%3E%3C!-- Heart / Like --%3E%3Cpath d='M65 42c-2.5-3-7-2-8 1.5-1-3.5-5.5-4.5-8-1.5-2.5 3 1 7.5 8 11.5 7-4 10.5-8.5 8-11.5z'/%3E%3C!-- Clock / Schedule --%3E%3Ccircle cx='25' cy='75' r='8'/%3E%3Cpath d='M25 71v4l3 2'/%3E%3C!-- Double Checkmarks --%3E%3Cpath d='M75 75l3 3 7-7'/%3E%3Cpath d='M80 75l3 3 7-7'/%3E%3C!-- Phone Receiver --%3E%3Cpath d='M100 95c-3 3-9 2-15-4s-7-12-4-15l4-2 4 6-2 3c1 3 3 5 6 6l3-2 6 4-2 4z'/%3E%3C!-- Smiley Face --%3E%3Ccircle cx='60' cy='95' r='9'/%3E%3Cpath d='M56 93h.01M64 93h.01' stroke-width='2'/%3E%3Cpath d='M56 97a4 4 0 0 0 8 0'/%3E%3C!-- Sparkles / Stars --%3E%3Cpath d='M60 15l1.5 3.5L65 20l-3.5 1.5L60 25l-1.5-3.5L55 20l3.5-1.5z'/%3E%3Cpath d='M105 55l1 2.5 2.5 1-2.5 1-1 2.5-1-2.5-2.5-1 2.5-1z'/%3E%3Cpath d='M15 105l1 2 2 1-2 1-1 2-1-2-2-1 2-1z'/%3E%3C!-- Audio Wave / Mic --%3E%3Cpath d='M40 70v10M36 73v4M44 72v6'/%3E%3C/g%3E%3C/svg%3E")`,
          backgroundRepeat: "repeat",
          backgroundSize: "180px 180px",
        }}
      />
    </div>
  );
};

export default AppBackground;
